import { View as a, cx as d, Button as s } from "@vectord/ui";
import e from "react";
function i({
  children: r,
  onClose: l,
  isOpen: v,
  className: n,
  contentContainerClass: t = ""
}) {
  return /* @__PURE__ */ e.createElement(a, { className: "vd-z-[99999]" }, v && /* @__PURE__ */ e.createElement(
    a,
    {
      className: d(
        "vd-fixed vd-bottom-none vd-right-none vd-left-none vd-w-full vd-h-full vd-bg-surface-neutral-inverse-base vd-z-[999] md:vd-items-center vd-justify-center",
        n
      )
    },
    /* @__PURE__ */ e.createElement("div", { className: d(
      "vd-absolute",
      t || ""
    ) }, r, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: "vd-absolute -vd-top-16 -vd-right-16 vd-cursor-pointer",
        onClick: l
      },
      /* @__PURE__ */ e.createElement(
        s,
        {
          size: "s",
          iconRight: "x",
          variants: "neutral",
          buttonType: "solid",
          className: "vd-py-8 vd-px-8 "
        }
      )
    ))
  ));
}
export {
  i as default
};
